export class UploadedFile {
    name: string;
    status: number;
    constructor(fileName: string, status: number) {
        this.name = fileName;
        this.status = status;
    }
}

export class RecommendedBank {
    id: string;
    perfiosInstitutionId: string;
    zestInstitutionCode: string;
    name: string;
    image: string;
    label: string;
    constructor(id: string, perfiosInstitutionId: string, zestInstitutionCode: string, name: string, image: string, label: string) {
        this.id = id;
        this.perfiosInstitutionId = perfiosInstitutionId;
        this.zestInstitutionCode = zestInstitutionCode;
        this.name = name;
        this.image = image;
        this.label = label;
    }
}

export class Statement {
    apiType: string;
    errorMessage: string;
    transactionState: string;
    uploadedFiles: UploadedFile[] = [];
    constructor(apiType: string, errorMessage: string, transactionState: string, fileNames: string[], status: number) {
        this.apiType = apiType;
        this.errorMessage = errorMessage;
        this.transactionState = transactionState;
        fileNames.forEach(fileName => {
            this.uploadedFiles.push(new UploadedFile(fileName, status));
        });
    }
}
